/**
 * Per-ad copy an operator edits in LaunchDarkly, no deploy.
 *
 * The `in-app-ads-copy` flag is an object keyed by AD ID — the same ids in
 * adKeys.js that dismissals and Mixpanel already key on, so the sidebar and the
 * export modal can be reworded independently the way the registry already words
 * them differently:
 *
 *   { "sidebar_referral_2026": { "headline": "…", "body": "…" },
 *     "export_referral_2026":  { "ctaLabel": "Share now" } }
 *
 * Only copy is overridable. A campaign's `emoji`, `image`, `href` and `prompt`
 * stay with the registry, and so does `id` — nothing here can reach targeting,
 * routing, tracking or dismissal.
 *
 * Applied to the ad that WON, not to the registry, so it also lands on the
 * `?previewAd=` path — which is how an operator checks a flag edit in
 * production before the campaign's real audience sees it.
 */
const OVERRIDABLE = ['headline', 'body', 'ctaLabel'];

/**
 * `ad` with its overridden copy, or `ad` itself — returned by identity when the
 * flag names nothing for it, so a slot that overrides nothing hands consumers
 * the same object every render.
 */
export const applyAdCopyOverride = (ad, config) => {
  const entry = ad && config?.[ad.id];
  if (!entry) return ad;

  const override = {};
  for (const key of OVERRIDABLE) {
    if (key in entry) override[key] = entry[key];
  }
  return Object.keys(override).length ? { ...ad, ...override } : ad;
};
